/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'object',
      properties: {
        unit: {
          type: 'string',
          enum: ['METRIC_TON'],
        },
        carbonIntensityScope1: {
          type: 'number',
        },
        carbonIntensityScope2: {
          type: 'number',
        },
        carbonIntensityScope3: {
          type: 'number',
        },
      },
      required: ['carbonIntensityScope1', 'unit', 'carbonIntensityScope2', 'carbonIntensityScope3'],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    carbon_intensity_scope: valueSchema,
  },
}
